import React from 'react';
import { YOUTUBE_VIDEOS } from '../data/sectionsData';
import ShowMoreButton from './ShowMoreButton';

const INITIAL_VISIBLE_YOUTUBE = 3;

export default function YouTubeSection({ expanded, onToggle, getVisibleItems }) {
    return (
        <section className="bg-inverse-surface py-16 md:py-24 px-4 md:px-6" id="youtube">
            <div className="max-w-[1200px] mx-auto">
                <div className="mb-16 reveal">
                    <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-red/15 text-accent-red rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                        <i className="fa-brands fa-youtube"></i> YouTube
                    </span>
                    <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-inverse-on-surface mb-2">On Camera</h2>
                    <p className="text-[1.0625rem] text-inverse-on-surface max-w-[560px] leading-relaxed">
                        I'd made a some videos about coding and few technologies.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {getVisibleItems('youtube', YOUTUBE_VIDEOS).map((v, i) => {
                        const videoId = new URL(v.link).pathname.slice(1);
                        return (
                            <div
                                key={i}
                                className={`group bg-white/[0.06] rounded-2xl overflow-hidden border border-white/[0.08] hover:bg-white/10 hover:-translate-y-1 hover:border-white/[0.15] transition-all duration-400 ease-emphasized reveal reveal-delay-${Math.min(i + 1, 4)}`}
                            >
                                {/* Embedded video */}
                                <div className="w-full aspect-video bg-black">
                                    <iframe
                                        src={`https://www.youtube.com/embed/${videoId}`}
                                        title={v.title}
                                        className="w-full h-full"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        loading="lazy"
                                    />
                                </div>
                                {/* Body */}
                                <div className="px-6 py-4">
                                    <a
                                        href={v.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-base font-semibold text-inverse-on-surface leading-snug hover:text-accent-red transition-colors duration-200"
                                    >
                                        {v.title}
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <ShowMoreButton
                    expanded={expanded}
                    onClick={onToggle}
                    totalCount={YOUTUBE_VIDEOS.length}
                    visibleCount={INITIAL_VISIBLE_YOUTUBE}
                    variant="youtube"
                />
            </div>
        </section>
    );
}
